import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, NavLink } from 'react-router-dom';
import 'App.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import ApartmentHotel from './ApartmentHotel/ApartmentHotel';
import RentBuy from './RentBuy/RentBuy';
import UnitCostAlternatives from './UnitCostAlternatives/UnitCostAlternatives';
import UnitCostCombos from './UnitCostCombos/UnitCostCombos';
import UnitCostBudgeting from './UnitCostBudgets/UnitCostBudgeting';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class App extends Component {
  constructor() {
    super();
    this.state = { title: "" }

    this.setTitle = this.setTitle.bind(this);
  }

  setTitle(newTitle) {
    this.setState({ title: newTitle });
  }

  render() {
    return (
      <Router>
        <div className="App">
          <header className="App-header"><span><Link to='/'>Calculate Decisions</Link></span><span>{this.state.title}</span></header>
          <Row>
            <Col xs={12} sm={3}>

              <div className="col-sm-auto sticky-top side-bar-content">
                <h1>Decisions</h1>
                <ul className="nav nav-pills flex-column nav-flush flex-sm-column flex-row flex-nowrap mb-auto mx-auto">
                  <li className='nav-item'><NavLink className='nav-link' to='/apartment-hotel' state={{ title: "value" }}>Hotel vs Serviced Apartment?</NavLink></li>
                  <li className='nav-item'><NavLink className='nav-link' to='/rent-buy' state={{ title: "value" }}>Rent vs Buy Home?</NavLink></li>
                  <li className='nav-item'><NavLink className='nav-link' to='/unit-cost-alternatives' state={{ title: "value" }}>Unit Cost Alternatives</NavLink></li>
                  <li className='nav-item'><NavLink className='nav-link' to='/unit-cost-combos' state={{ title: "value" }}>Unit Cost Combos</NavLink></li>
                  <li className='nav-item'><NavLink className='nav-link' to='/unit-cost-budgeting' state={{ title: "value" }}>Unit Cost Budgeting</NavLink></li>
                </ul>
              </div>
            </Col>
            <Col className="app-side col-sm p-3 min-vh-100">
              <Routes>
                <Route path='/rent-buy' element={<RentBuy setTitle={this.setTitle} />} />
                <Route path='/apartment-hotel' element={<ApartmentHotel setTitle={this.setTitle} />} />
                <Route path='/unit-cost-alternatives/*' element={<UnitCostAlternatives setTitle={this.setTitle} />} />
                <Route path='/unit-cost-combos/*' element={<UnitCostCombos setTitle={this.setTitle} />} />
                <Route path='/unit-cost-budgeting/*' element={<UnitCostBudgeting setTitle={this.setTitle} />} />
              </Routes>
            </Col>
          </Row>

        </div>
      </Router>
    );
  }
}

export default App;
